import cx from "clsx";
import { FileHandle } from "kreate-common/modules/business-types";
import React from "react";

import PrimaryHtmlViewer from "./containers/PrimaryHtmlViewer";
import PrimaryImageViewer from "./containers/PrimaryImageViewer";
import PrimaryVideoViewer from "./containers/PrimaryVideoViewer";
import styles from "./index.module.scss";
import { getContentCategory } from "./utils";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  file: FileHandle | null | undefined;
  thumbnailFile: FileHandle | null | undefined;
  fill: true;
  sizes: string | undefined;
};

/**
 * `PrimaryFileViewer` is used to display an image/video which is
 * the main content. Typically, it can be used in `PageArtwork`
 * and `PageCreateArtwork`.
 */
export default function PrimaryFileViewer({
  className,
  style,
  file,
  thumbnailFile,
  sizes,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      {(() => {
        switch (getContentCategory(file?.blob.contentType)) {
          case "image":
            return <PrimaryImageViewer file={file} sizes={sizes} fill />;
          case "video":
            return (
              <PrimaryVideoViewer
                file={file}
                thumbnailFile={thumbnailFile}
                fill
              />
            );
          case "html":
            return <PrimaryHtmlViewer file={file} fill />;
          default:
            return undefined;
        }
      })()}
    </div>
  );
}
